import { Pipe, PipeTransform } from '@angular/core'
/**
 * Math.min
 */
@Pipe({
  name: 'max',
})
export class MaxPipe implements PipeTransform {
  transform(value: number | undefined | null, maxValue: number): number | undefined {
    if (value !== undefined && value !== null) {
      return Math.max(value, maxValue)
    }
    return
  }
}
